<site-header />

<main class="flex flex-1 flex-col">
  @if (activeRoute.header(); as header) {
  <section-header [header]="header" />
  }

  <div class="flex-1 p-4 pb-[calc(6.5rem+env(safe-area-inset-bottom))]">
    <router-outlet />
  </div>
</main>

<bottom-nav />
